import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import ContentSection from '../components/ContentSection';
import Mantra from '../components/Mantra';
import Footer from '../components/Footer';
import '../styles/App.css';
import MantraImage from '../assets/images/Mantra_1.png';
import SamGallery1 from '../assets/images/Sam_DuRegger-track.png';
import SamGallery2 from '../assets/images/Sam_DuRegger-fb.png';
import SamGallery3 from '../assets/images/Sam_DuRegger-fb-2.png';
import CandaceGallery1 from '../assets/images/Candace_Wilson-1.png';
import CandaceGallery2 from '../assets/images/Candace_Wilson-2.png';
import CandaceGallery3 from '../assets/images/Candace_Wilson-3.png';

function About() {
 
   
  const Mission = {
	  sectionTitle: (
		<>
		  BEGIN <span style={{ color: 'red' }}>Strength</span>
		</>
	  ),
	  sectionDescription:
		'In a safe and supportive space, we empower coaches and athletes to grow stronger in body, mind, and purpose.',
	  items: [
		{
		  title: 'Our Mission',
		  body1: (
			<>
			  <p>
				Our mission is to provide youth and club coaches access to a professional facility where they can train their athletes in fitness and functional strength practices. These foundations don’t just enhance athletic performance—they build resilience, reduce injury, and create healthy habits that athletes can carry through their careers and into life.
			  </p>
			</>
		  ),
		  subtitle2: 'Begin, Begun, Begin again.',
		  body2: (
			<>
			  <p>
				We provide Coaches a professional environment to train their athletes in sport-specific and functional strength. We believe holistic training is the formula for long-term success in sport and life.
			  </p>
			  <p>
				Our mantra is a reflection of how we see the world - we are here to begin, and finish what we’ve begun, so we can begin again.
			  </p>
			  <ul>
				<li><span style={{ color: 'red' }}>Begin:</span>  The first step—starting our fitness journey, learning the basics, and building a foundation.</li>
			  <li><span style={{ color: 'red' }}>Begun:</span>  Progression—developing strength, endurance, and skill as we do work that makes us better.</li>
			  <li><span style={{ color: 'red' }}>Begin Again:</span>  Fitness is a lifelong commitment—in overcoming setbacks and learning from our mistakes, we continue our growth.</li>
			  </ul>
			</>
		  ),
		  subtitle3: 'Begin Now → Keep Going → Grow Stronger',
		},
	  ],
	};

  const OurStory = {
	sectionTitle: (
	  <>
		About <span style={{ color: 'red' }}>Us</span>
	  </>
	),
	sectionDescription:
	  'We start with the Begin Strength app—programs, periodization, and performance tracking—so athletes and coaches can train anywhere. A physical space for coaches and athletes is in our future.',
	items: [
	  {
	title: 'Our Story',
	body1: (
			<>
			  <p>
			  We founded Begin Strength in 2023 as we began training and coaching our daughters in athletics. In navigating the youth sports world, we saw a clear gap: while skills were being taught, functional strength training was often overlooked. The result? Athletes have strong sport-specific skills but lack overall fitness, balance, and strength—key elements that reduce the risk of injury and burnout.
			  </p>
			  <p>
			  Begin Strength was created to fill that gap. We start with the app—programs, periodization, and performance tracking—so athletes and coaches can train anywhere, any time. A physical facility where coaches can train their athletes remains part of our vision for the future.
			  </p>
		  </>
		  		),
			  },
			],
		  };
		  
const Bio_Candace = {
		  sectionTitle: (
			<>
			  Our <span style={{ color: 'red' }}>Founders</span>
			</>
		  ),
		  sectionDescription:
			'From small-town achievements to college performance, our athletic journey has brought us confidence, life-long health, and how to win with a team.',
		  gallery: [CandaceGallery1, CandaceGallery2, CandaceGallery3], // Added Gallery here
		  items: [
			{
		  title: 'Candace DuRegger',
		  subtitle1: 'Central College, 1997-2001',
		  body1: (
				  <>
				<p>
					<em>The following was written for Candace’s <a href="https://athletics.central.edu/sports/2017/8/3/candace-wilson-duregger-01.aspx?id=474" target="_blank" rel="noreferrer">induction into the Central College’s Hall of Honor</a> in 2016.</em>
				</p>
				<p>	
					The only four-time volleyball honoree ever for the Dutch, Candace Wilson, now Candace DuRegger, starred in one of the most dominant four-year runs of any team in Central history. The Dutch compiled a glossy 154-8 record during her career, which included a national third-place finish in 1997, followed by three consecutive NCAA Division III championships.
				</p>
				<p>
					A 6-foot-1 middle hitter, Candace’s quickness, leaping ability and long arms made her a dominant force at the net. She set school career marks for kills (2,008), attacks (3,780) and blocks (641) along with attack percentage standards for a season (.425, 1999) and career (.398), numbers that rank among the best ever in Division III. She recorded 35 statistical double-doubles.
				</p>
				<p>
					In 1997, Candace was a second-team all-America honoree before gaining first-team distinction the following three years. Candace teamed with fellow middle hitter Abbie Brown Sogard ’00, a 2015 hall of honor inductee, for the first two NCAA crowns, then captured another in 2000 following Sogard’s graduation, and was tabbed Iowa Conference MVP and national player of the year. Central’s 1999 squad ranks among Division III’s most dominant, posting a 41-0 record with only one match getting extended to a full five sets. Central broke the all-time, all-divisions NCAA record by winning 60 consecutive matches from 1998-2000. Candace closed her career in 2000 with a national title-match victory over Wis.-Whitewater at home in a sold-out P.H. Kuyper Gymnasium.
				</p>
				<p>
					Central rolled to conference titles all four years, never losing a league match.
				</p>
				<p>
					Following her freshman season, Candace also joined the women’s basketball squad in December and helped the Dutch win a share of the league title in 1997-98, advancing to the NCAA tournament, she averaged 4.4 points, 4.3 rebounds and 1.0 blocks during the season.
				</p>
				</>
				),
				  subtitle2: 'Coaching Experience',
				  body2: (
					<>
						<ul>
						<li>• Volunteer Asst. Coach at Bethel College, in Minneapolis, Minnesota</li>
						<li>• Club volleyball coach for various age groups in Minneapolis, Minnesota</li>
						<li>• Club Coach for 15s in Salt Lake City, UT</li>
						<li>• Assistant Jr. High Volleyball Coach at Oakdale in Oklahoma City, Oklahoma</li>
						</ul>
					  </>
					),
					subtitle3: 'Awards',
					  body3: (
						<>
							<ul>
							<li>• 3 x NCAA Division III Champion</li>
							<li>• 4 x All-American</li>
							<li>• National Player of the year in 2000</li>
							<li>• Iowa Conference MVP in 2000</li>
							<li>• 2016 Central College Hall of Honor</li>
							</ul>
						  </>
						),
				  },
			  ],
			};	
			
const Bio_Sam = {
			  gallery: [SamGallery1, SamGallery2, SamGallery3], // Added Gallery here
			  items: [
				{
			  title: 'Sam DuRegger',
			  subtitle1: 'The University of Tulsa, 1997-2001',
			  body1: (
					  <>
					<p>
						Sam ran track at The University of Tulsa after a successful high school career helping his team to the Iowa Class 2A State Championship in Track and Field in 1996. Sam was a two-time Drake Relays participant in 1996 and 1997. 
					</p>
					<p>	
						Sam ran 200’s and 400’s for the Golden Hurricane during the 1997/98 seasons earning a Varisty Letter his Freshman year in indoor and outdoor track seasons. During Sam's sophomore year, he joined the Football team as a walk-on receiver, making the travel squad his Junior year after a breakout performance in Tulsa's Spring Football scrimmage in 2000, followed by participation in the Tulsa’s Summer Strength Program. Sam made his collegiate football debut versus the North Carolina Tar Heels in Chapel Hill and earned a start at slot receiver versus New Mexico State. He finished his career after the 2001 season, fulfilling his childhood goal of playing Division I football. Sam was named to the All-WAC (Western Athletic Conference) Academic team his Junior and Senior seasons at TU.
					</p>
					
					</>
					),
					  subtitle2: 'Coaching Experience',
					  body2: (
						<>
							<ul>
							<li>• USA Track & Field Certified Coach</li>
							<li>• USA Triathlon, Level 1 Certification</li>
							</ul>
						  </>
						),
						subtitle3: 'Awards',
						  body3: (
							<>
								<ul>
								<li>• 1 x Track & Field Letterman</li>
								<li>• 2 x Football Letterman</li>
								<li>• 2 x All-WAC Academic Team</li>
								</ul>
							  </>
							),
					  },
				  ],
				};	  

  return (
	<div className="home">
	  <SEO
		title="About Us"
		description="Begin Strength was founded to fill the gap in youth sports. We start with the app—programs, periodization, and performance tracking—so athletes and coaches can train anywhere. A physical space is in our future."
		image="/social-media-image.png"
		path="/about"
	  />
	  <Header />
	  <main>
	
	<ContentSection  
	  sectionTitle={OurStory.sectionTitle}
	  sectionDescription={OurStory.sectionDescription}
	  items={OurStory.items}
	  sectionClass="faq-sub-section"
	  showNumbers={false}
	  spacer={true}
	/>
	
	<ContentSection  
	  sectionTitle={Bio_Candace.sectionTitle}
	  sectionDescription={Bio_Candace.sectionDescription}
	  gallery={Bio_Candace.gallery} // Passing the gallery images
	  items={Bio_Candace.items}
	  sectionClass="faq-sub-section"
	  showNumbers={false}
	/>
	
	<ContentSection  
	  sectionTitle={Bio_Sam.sectionTitle}
	  sectionDescription={Bio_Sam.sectionDescription}
	  gallery={Bio_Sam.gallery} // Passing the gallery images
	  items={Bio_Sam.items}
	  sectionClass="faq-sub-section"
	  showNumbers={false}
	/>

		<Mantra
		  backgroundImage={MantraImage}
		  mantraText="Every day we Begin Again"
		/>

		<ContentSection 
		  sectionTitle={Mission.sectionTitle}
		  sectionDescription={Mission.sectionDescription}
		  items={Mission.items}
		  sectionClass="faq-sub-section"
		  showNumbers={false}
		  
		/>
		
		
		
	

		<Footer />
	  </main>
	</div>
  );
}

export default About;
